import { Pipe, PipeTransform } from '@angular/core';
import { PurchaseItem } from '@greco/sales-purchases';

@Pipe({ name: 'containsItem' })
export class ContainsItemPipe implements PipeTransform {
  transform(id: string, items: PurchaseItem[]): boolean {
    return items.some(item => item.id === id);
  }
}
